import { Component } from '@angular/core';
import { INPUT_VALUE_COVER_TYPE_SOFT } from '@shared/common/product';
import type { TBookAlias, TBookCover } from '@shared/jp/product';
import type { IBookPreview } from '@shared/jp/data/products';
import { EGiftOrderType } from '@shared/common/gift';
import { REGION_NAME_ENGLISH_DEFAULT } from '@shared/jp/shipping/constants';
import { DiscountService } from 'src/app/services/discount.service';
import { ProductionService } from 'src/app/services/production.service';
import { BehaviorSubject, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GiftBooks } from '../gift-buy-page/gift-buy-page.data';

@Component({
  templateUrl: './gift-buy-special-page.component.html',
  styleUrls: ['./gift-buy-special-page.component.scss'],
})
export class GiftBuySpecialPageComponent {
  get alias() {
    return this._alias$.value;
  }

  set alias(value: TBookAlias | undefined) {
    this._alias$.next(value);
  }

  private _alias$ = new BehaviorSubject<TBookAlias | undefined>(undefined);

  public cover: TBookCover = INPUT_VALUE_COVER_TYPE_SOFT;

  /**
   * mapped with adding `SHIPPING_REGULAR_PRICE` to each `IPrice['value']`
   */
  public readonly Books: IBookPreview[] = GiftBooks;

  public readonly EGiftOrderType = EGiftOrderType;

  get book(): IBookPreview | undefined {
    const { alias, Books: _Books } = this;

    return alias && _Books.find((b) => b.alias === alias);
  }

  public shipping$ = this._productionService.getShippingRegular$(
    of({ booksCount: 1, regionName: REGION_NAME_ENGLISH_DEFAULT }),
  );

  public discount$ = this._alias$.pipe(
    switchMap((alias) =>
      alias ? this._discountService.getDiscount$(alias) : of(undefined),
    ),
  );

  public shippingDiscount$ = this.shipping$.pipe(
    switchMap((shippingMethod) =>
      this._discountService.getShippingDiscount$(shippingMethod.id),
    ),
  );

  constructor(
    private _productionService: ProductionService,
    private _discountService: DiscountService,
  ) {}
}
